import { axiosGetFile } from '../ServiceBase.js';

export const getFile = async (url) => {
  return axiosGetFile(`/v1/files${url}`);
};
